import { useState, useEffect} from 'react';
import { motion } from 'framer-motion';
import { urlFor, client } from '../../client';
import { AppWrap, MotionWrap } from '../../wrapper';
import {images} from '../../constants';
import './About.scss';

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
      const query ='*[_type == "abouts"]';

      client.fetch(query)
        .then((data) => setAbouts(data));
  }, [])
  

  return (
    <div className='app__about'>
      <div className='app__about-page' >
          <div className='app__about-img'>
            <img src={images.aboutImg} alt="profile" />
          </div>
          
          <div className='app__about-text'>
            <h2 className='head-text'>
              About <span>Me</span><hr />
            </h2>
            <p className='p-text'>
              Hi, I'm <span>Samuel K. Tetteh</span>, a skilled <span>Web Developer</span> with a passion for creating beautiful, functional websites. I specialize in <span>MERN-Stack Development</span>.
              I'm passionate about <span>creating clean, efficient code</span> and <span>staying up-to-date</span> with the latest web development trends and technologies. In my free time, I enjoy reading blogs related to web development, or building personal projects. 
              <span> Take a look at some of my specialties</span> and <a href="#work" className='link'><span>projects</span></a> below, and don't hesitate to <a href="#contact" className='link'><span>get in touch</span></a> if you're interested in working together.
            </p>
          </div>
      </div>

      <div className="app__profiles">
          { abouts.map((about, index) => (
            <motion.div
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__profile-item"
              key={about.title + index}
            >
              <img src={urlFor(about.imgUrl)} alt={about.title} />
              <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
              <p className='p-text' style={{ marginTop: 10 }}>{about.description}</p>
            </motion.div>
          ))}
      </div>
    </div>
  );
}

export default AppWrap(
  MotionWrap(About, 'app__about'), 
  'about',
  'app__whitebg'
  );